import React from 'react';
import { Box } from '@material-ui/core';
import './styles.css';


export default function Loading() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="calc(100% - 72px)">
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </Box>
  )
}